//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SiteStopApplyList from "./SiteStopApplyList";
import SiteStartList from "./SiteStartList";
export default {
  name: 'SiteStopList',
  components: {
    SiteStopApplyList: SiteStopApplyList,
    SiteStartList: SiteStartList
  },
  data: function data() {
    return {
      tabKey: '1'
    };
  }
};